import { render } from "./client-domain-clients.vue?vue&type=template&id=11b8fbbf"
import script from "./client-domain-clients.vue?vue&type=script&lang=js"
export * from "./client-domain-clients.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__